module.exports = __webpack_public_path__ + "img/step-arrow.bbbd6838.png";